import { ObjectUtils } from "~app/common/utils/object-utils";
import { IArbetsorderAtgarder } from "~app/features/planera/model/IArbetsorderAtgarder";
import { IAtgardskedjaKoppling } from "~app/features/planera/model/IAtgardskedja";

export class ArbetsorderAtgardskedjaBehaviour {
    constructor(private readonly arbetsorder: IArbetsorderAtgarder) { }

    /**
     *
     * @param atgardId Valfritt filter på åtgärdens Id
     * @returns Alla relaterade åtgärdskopplingar på Arbetsorder om valfritt vilkor ej används
     */
    getRelateradeAtgardskopplingar = (atgardId?: number): IAtgardskedjaKoppling[] => {
        const arbetsorder = this.arbetsorder;
        if (!arbetsorder || !arbetsorder.atgarder) {
            return null;
        }

        let atgarder = arbetsorder.atgarder;
        if (!ObjectUtils.isNullOrUndefined(atgardId)) {
            atgarder = atgarder.filter(x => x.id === atgardId);
        }

        const tentatives = atgarder.reduce((all, atgard) => {
            if (atgard.atgardskedja != null) {
                all.push(...atgard.atgardskedja.atgardskedjaKopplingar
                    .filter(akk => akk.arbetsorderId !== arbetsorder.id));
            }
            return all;
        }, []);

        if (!tentatives.length) {
            return null;
        }

        // Välj den koppling som har den arbetsorder med senast skordat datum
        tentatives.sort((l, r) => {
            const ldate = l.arbetsorderSkordningAvslutadDatum ? new Date(l.arbetsorderSkordningAvslutadDatum) : new Date(1970, 1, 1);
            const rdate = r.arbetsorderSkordningAvslutadDatum ? new Date(r.arbetsorderSkordningAvslutadDatum) : new Date(1970, 1, 1);
            return rdate.getTime() - ldate.getTime();
        });

        return tentatives;
    };

    getRelateradAtgardskoppling = (): IAtgardskedjaKoppling[] => {
        const tentatives = this.getRelateradeAtgardskopplingar();
        if (!tentatives || tentatives.length === 0) {
            return null;
        }

        const result: IAtgardskedjaKoppling[] = [];
        tentatives.forEach(t => {
            if (ObjectUtils.isNullOrUndefined(result.find(p => p.arbetsorderId === t.arbetsorderId))) {
                result.push(t);
            }
        });

        return result;
    };
}
